import { createFileRoute } from '@tanstack/react-router';
import { Home } from '@/features/consumer/home';

export const Route = createFileRoute('/(consumer)/_public/home')({
  component: Home,
  head: () => ({
    links: [
      // Canonical for /home (static index.html canonical points to /)
      { rel: 'canonical', href: 'https://itriahome.com/home' },
      // Preload the LCP hero image for client-side navigations to /home.
      // Dark mode is default (defaultValue: true in DarkModeProvider).
      // The inline script in index.html handles the initial hard-load preload.
      {
        rel: 'preload',
        as: 'image',
        href: '/images/hero-img-dark-800.webp',
        type: 'image/webp',
        imageSrcSet:
          '/images/hero-img-dark-800.webp 800w, /images/hero-img-dark-1600.webp 1600w',
        imageSizes: '(max-width: 768px) 800px, 1600px',
      },
    ],
  }),
});
